import { useEffect, useState } from 'react';

const QUERY = '(min-width: 1024px) and (prefers-reduced-motion: no-preference)';

/** True when a pinned scroll story should run: desktop width and motion allowed. Updates on resize. */
export function useScrollStory(): boolean {
  const [enabled, setEnabled] = useState(() => typeof window !== 'undefined' && !!window.matchMedia?.(QUERY).matches);
  useEffect(() => {
    const mql = window.matchMedia?.(QUERY);
    if (!mql) return;
    const onChange = () => setEnabled(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);
  return enabled;
}
